"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stateReducer = stateReducer;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _defaultState = require("./defaultState");
var _view = require("../../types/view");
var _state = require("../../actions/state");
var _utils = require("./utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function stateReducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _defaultState.defaultState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _state.EStateActionTypes.SetState:
      return action.payload;
    case _state.EStateActionTypes.ResetStateToUsernameAuth:
      return _objectSpread(_objectSpread({}, _defaultState.defaultState), {}, {
        view: _objectSpread({
          active: _view.EActiveView.AuthenticationRegistration
        }, (0, _utils.getActualViewData)(state)),
        social: _objectSpread(_objectSpread({}, _defaultState.defaultState.social), {}, {
          expanded: state.social.expanded
        }),
        isRememberAccountsFlow: state.isRememberAccountsFlow,
        registration: _objectSpread(_objectSpread({}, _defaultState.defaultState.registration), {}, {
          isProfessionalUser: state.registration.isProfessionalUser
        }),
        source: state.source
      });
    case _state.EStateActionTypes.ResetStateToPhoneAuth:
      return _objectSpread(_objectSpread({}, _defaultState.defaultState), {}, {
        view: _objectSpread({
          active: _view.EActiveView.PhoneAuth
        }, (0, _utils.getActualViewData)(state)),
        social: _objectSpread(_objectSpread({}, _defaultState.defaultState.social), {}, {
          expanded: state.social.expanded
        }),
        isRememberAccountsFlow: state.isRememberAccountsFlow,
        registration: _objectSpread(_objectSpread({}, _defaultState.defaultState.registration), {}, {
          isProfessionalUser: state.registration.isProfessionalUser
        }),
        source: state.source
      });
    case _state.EStateActionTypes.ChangeStateToUsernameAuth:
      return _objectSpread(_objectSpread({}, _defaultState.defaultState), {}, {
        login: action.payload,
        view: _objectSpread({
          active: _view.EActiveView.AuthenticationRegistration
        }, (0, _utils.getActualViewData)(state)),
        social: _objectSpread(_objectSpread({}, _defaultState.defaultState.social), {}, {
          expanded: state.social.expanded
        }),
        isRememberAccountsFlow: state.isRememberAccountsFlow,
        registration: _objectSpread(_objectSpread({}, _defaultState.defaultState.registration), {}, {
          isProfessionalUser: state.registration.isProfessionalUser
        }),
        source: state.source
      });
    case _state.EStateActionTypes.ChangeStateToPhoneAuth:
      return _objectSpread(_objectSpread({}, _defaultState.defaultState), {}, {
        phoneAuth: _objectSpread(_objectSpread({}, _defaultState.defaultState.phoneAuth), {}, {
          phone: action.payload
        }),
        view: _objectSpread({
          active: _view.EActiveView.PhoneAuth
        }, (0, _utils.getActualViewData)(state)),
        social: _objectSpread(_objectSpread({}, _defaultState.defaultState.social), {}, {
          expanded: state.social.expanded
        }),
        isRememberAccountsFlow: state.isRememberAccountsFlow,
        registration: _objectSpread(_objectSpread({}, _defaultState.defaultState.registration), {}, {
          isProfessionalUser: state.registration.isProfessionalUser
        }),
        source: state.source
      });
    default:
      return state;
  }
}